@if (!value) {
  <i class="far fa-times-circle global-table-cell-image-only statuses status-no"
  [ngClass]="{'statuses-reverse-colors': reverseColors, 'statuses-show-negative-only': showNegativeOnly, 'statuses-show-positive-only': showPositiveOnly}"></i>
}
@if (value) {
  <i class="far fa-check-circle global-table-cell-image-only statuses status-yes"
  [ngClass]="{'statuses-reverse-colors': reverseColors, 'statuses-show-negative-only': showNegativeOnly, 'statuses-show-positive-only': showPositiveOnly}"></i>
}
